// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// import iph1 from "../../assets/integrated-post-1.jpg";
// import iph2 from "../../assets/integrated-post-2.jpg";
// import iph3 from "../../assets/integrated-post-3.jpg";
// import iph4 from "../../assets/integrated-post-4.jpg";
// import iph5 from "../../assets/integrated-post-5.jpg";
// import iph6 from "../../assets/integrated-post-6.jpg";
// import iph7 from "../../assets/integrated-post-7.jpg";
// import iph8 from "../../assets/integrated-post-8.jpg";


// export default function IPH() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Integrated Post Harvest Management projects from NHB</h1>

//                                   <h2>Integrated Post Harvest Management projects</h2>
//                                   <p>(a) Activity (ies) allowed</p>
//                                   <p>The Board will take up Integrated Post Harvest Management projects relating to Pack House, Ripening Chamber, Refer Van, Retail Outlets, Pre- cooling unit, Primary processing etc.</p>
//                                   <p>NHB will also take up projects in component mode and for standalone projects of PHM components.</p>
//                                   <p>(b) Crops eligible: In case of primary processing, projects related to Fruits, Vegetables, Flowers, Aromatic plants and Cashew are only eligible for subsidy.</p>
//                                   <p>(c) Pattern of assistance: Credit linked back-ended subsidy @ 35% of the total project cost limited to Rs 50.75 lakh per project in general area and @ 50 % of project cost limited to Rs. 72.50 lakh per project in NE Region, Hilly States and Scheduled areas.</p>
//                                   <p>(d) Maximum Project costs allowed for subsidy calculation.</p>
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                              <div>
//                                   <img src={iph1} alt="IPH" className="img-fluid mb-3" />
//                                     <img src={iph2} alt="IPH" className="img-fluid mb-3" />
//                                     <img src={iph3} alt="IPH" className="img-fluid b-block mx-auto mb-3" />
//                                     <img src={iph4} alt="IPH" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={iph5} alt="IPH" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={iph6} alt="IPH" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={iph7} alt="IPH" className="img-fluid b-block mx-auto mb-3" />
//                                   <img src={iph8} alt="IPH" className="img-fluid b-block mx-auto mb-3" />

//                                   <p>1.3.e.Technical Standards : Project should strictly comply with the prescribed Technical standards of NCCD, else the project is not eligible for any financial assistance. The standards can be accessed at the link http://nhb.gov.in/guideline/NCCDGuidelines2014-15.pdf.</p>
                             
//                              </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// };

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping,
} from "react-icons/fa";

export default function IPH() {
  return (
    <div className="bg-light py-5">
      <Container>

        {/* TITLE */}
        <Row>
          <Col lg={12}>
            <h1>
              Integrated Post Harvest Management (NHB)
            </h1>

            <p>
              The NHB scheme supports infrastructure that reduces post-harvest losses
              and improves shelf life of horticulture produce through modern storage,
              processing, and supply chain systems.
            </p>
          </Col>
        </Row>

        {/* OBJECTIVE */}
        <h2 className="section-title">
          <FaGlobe /> Objective of the Scheme
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Minimize post-harvest losses</li>
          <li><FaCheckCircle /> Improve quality & shelf life</li>
          <li><FaCheckCircle /> Strengthen cold chain</li>
          <li><FaCheckCircle /> Increase farmer income</li>
          <li><FaCheckCircle /> Promote value addition</li>
        </ul>

        {/* WHAT IS */}
        <h2 className="section-title">
          <FaList /> What are Post Harvest Projects
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Pack houses</li>
          <li><FaCheckCircle /> Cold storage units</li>
          <li><FaCheckCircle /> Ripening chambers</li>
          <li><FaCheckCircle /> Pre-cooling units</li>
          <li><FaCheckCircle /> Processing units</li>
          <li><FaCheckCircle /> Reefer transport & retail</li>
        </ul>

        {/* SUBSIDY */}
        <h2 className="section-title">
          <FaRocket /> Subsidy Pattern
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> 35% subsidy (General areas)</li>
          <li><FaCheckCircle /> 50% subsidy (NE / Hilly areas)</li>
          <li><FaCheckCircle /> Max ₹50.75L / ₹72.50L</li>
          <li><FaCheckCircle /> Credit-linked subsidy</li>
        </ul>

        {/* PROJECT COST TABLE */}
        {/* <h2 className="section-title">
          📊 Project Cost Overview
        </h2>

        <div className="cost-table dark">
          <p className="cost-subtitle">
            Typical cost norms under the scheme:
          </p> */}

          {/* <div className="table-row table-head">
            <span>Component</span>
            <span>Approx Cost</span>
          </div>

          {[
            ["Pack House", "₹4L – ₹50L"],
            ["Pre-Cooling Unit", "₹25L"],
            ["Cold Room", "₹15L"],
            ["Mobile Pre-Cooling", "₹25L"],
            ["Ripening Chamber", "₹1L per MT"],
            ["Processing Unit", "₹25L"],
            ["Retail Outlet", "₹15L"]
          ].map((item, index) => (
            <div key={index} className="table-row">
              <span>{item[0]}</span>
              <span>{item[1]}</span>
            </div>
          ))} */}

          {/* PROJECT COST TABLE */}
<h2 className="section-title">📊 Project Cost Overview</h2>

<div className="table-responsive mt-3">
  <table className="table cost-table-main">
    <thead>
      <tr>
        <th>Component</th>
        <th>Approximate Cost</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Pack House</td>
        <td>₹4 lakh – ₹50 lakh</td>
      </tr>
      <tr>
        <td>Pre-Cooling Unit</td>
        <td>₹25 lakh</td>
      </tr>
      <tr>
        <td>Cold Room</td>
        <td>₹15 lakh</td>
      </tr>
      <tr>
        <td>Mobile Pre-Cooling</td>
        <td>₹25 lakh</td>
      </tr>
      <tr>
        <td>Ripening Chamber</td>
        <td>₹1 lakh per MT</td>
      </tr>
      <tr>
        <td>Processing Unit</td>
        <td>₹25 lakh</td>
      </tr>
      <tr>
        <td>Retail Outlet</td>
        <td>₹15 lakh</td>
      </tr>
    </tbody>
  </table>
</div>

<p className="table-note">
  💡 Actual cost varies based on size, technology, and capacity.
</p>

          {/* <p className="cost-note">
            💡 Actual cost varies based on size, technology, and capacity.
          </p>
        </div> */}

        {/* BENEFITS */}
        <h2 className="section-title">
          <FaIndustry /> Benefits
        </h2>

        <ul className="custom-list">
          <li><FaCheckCircle /> Reduce wastage up to 40%</li>
          <li><FaCheckCircle /> Improve product quality</li>
          <li><FaCheckCircle /> Increase farmer income</li>
          <li><FaCheckCircle /> Enable exports</li>
          <li><FaCheckCircle /> Year-round availability</li>
        </ul>

        {/* HELP */}
        <h2 className="section-title">
          <FaHandsHelping /> How We Help You
        </h2>

        <p>
          We provide DPR preparation, bank loan support, subsidy filing,
          NHB coordination, and complete execution guidance.
        </p>

      </Container>
    </div>
  );
}
